/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const getOpenapi200Schema = z.any();

export const getOpenapiQueryResponseSchema = z.lazy(() => getOpenapi200Schema);
